module.exports = __webpack_public_path__ + "img/cash-wallet.28ea6966.webp";